import { render, staticRenderFns } from "./aiRecommendation.vue?vue&type=template&id=720b1442&"
import script from "./aiRecommendation.vue?vue&type=script&lang=js&"
export * from "./aiRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./aiRecommendation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports